import { CSSProperties, HTMLAttributes, DetailedHTMLProps } from 'react'
import clsx from 'clsx'

type Div = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

type RowProps = Div & {
  className?: string
  justifyContent?: CSSProperties['justifyContent']
  alignItems?: CSSProperties['alignItems']
  width?: CSSProperties['width']
  height?: CSSProperties['height']
  style?: CSSProperties
}

export const Row = ({
  children,
  className,
  justifyContent = 'center',
  alignItems = 'center',
  width,
  style,
  height,
  ...rest
}: RowProps) => {
  return (
    <div
      className={clsx(className)}
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent,
        alignItems,
        width,
        height,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  )
}
